import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { AccordionContentComponent } from './accordion-content.component';
import { foldDownUpAnimation } from '../../../shared/animations/fold.downUp.animation';

@Component({
    selector: 'mlp-ng-accordion-container',
    template: '<ng-content></ng-content>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [foldDownUpAnimation]
})
export class AccordionContainerComponent implements AfterContentInit {
    @ContentChildren(AccordionContentComponent) panels: QueryList<AccordionContentComponent>;

    ngAfterContentInit() {
        this.panels.toArray().forEach((panel: AccordionContentComponent) => {
            panel.toggle.subscribe(() => {
                this.openPanel(panel);
            });
        });
    }

    openPanel(panel: AccordionContentComponent) {
        this.panels.toArray().forEach(p => p.open = false);
        panel.open = true;
    }
}
